<template>
  <div class="drop">
    <v-layout justify-center align-content-center align-center column>
      <v-icon color="#ED722F" size="75" style="padding-right:10px">mdi-alert-decagram</v-icon>
      <h2 style="color:#00558C">Unauthorized Access Attempt</h2>
      <v-card-subtitle>You have attempted to reach a page for which your current role is not authorized or you need to re-authenticate.</v-card-subtitle>
      <v-card-subtitle>
        Please click
        <a @click="$router.push('/')">here</a> to be redirected.
      </v-card-subtitle>
    </v-layout>
  </div>
</template>
<script>
export default {};
</script>
<style scoped>
.drop {
  margin-top: 150px;
}
</style>